import { SearchIcon } from "@heroicons/react/solid"
import { getDefaultFilter, useTranslation } from "@refinedev/core";
import Button from "components/button"
import Input from "components/input"
import Select from "components/select"
import { useState } from "react";
import { EVENT_STEP_STATUS_OPTIONS_BY_LOCALE } from "utills/constants";

export const Filter = ({ filters, setFilters, pagingType = "offset"}: {filters: any, setFilters: any, pagingType?: "offset" | "page"}) => {
  const { translate } = useTranslation();
  const _handleSubmitFilter = () => {
    setFilters([
      {field: "q", operator: "contains", value: keyword},
      {field: "status", operator: "eq", value: status},
      {field: pagingType, operator: "eq", value: pagingType === "offset" ? 0 : 1}
    ])
  }
  
  const [keyword, setKeyword] = useState(getDefaultFilter("q", filters, "contains") ?? "");
  const [status, setStatus] = useState<string>(getDefaultFilter("status", filters, "eq") ?? "");
  
  return (
    <div className="w-full flex flex-col gap-y-4 md:flex-row md:items-end md:gap-x-3">
      <div className="flex-1 md:max-w-md">
        <label htmlFor="name" className="block text-sm font-medium leading-6">
          {translate("search")}
        </label>
        <div className="mt-2">
          <Input 
            className="px-2 py-2"
            id='name'
            type="text"
            placeholder={translate("search-by-event-name")}
            value={keyword}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKeyword(e.target.value)}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter') {
                _handleSubmitFilter();
              }
            }}
          />
        </div>
      </div>
      <div className="flex-1 md:max-w-44">
        <label htmlFor="status" className="block text-sm font-medium leading-6">
          {translate("status")}
        </label>
        <div className="mt-2">
          <Select 
            options={EVENT_STEP_STATUS_OPTIONS_BY_LOCALE} 
            id="status"
            placeholder={translate("select-status")}
            className="py-0.5"
            value={EVENT_STEP_STATUS_OPTIONS_BY_LOCALE.find((d) => d.value === status)}
            onChange={(selected: {label: string; value: string}) => setStatus(selected?.value)}
          />
        </div>
      </div>
      
      <div className="shrink-0">
        <label htmlFor="status" className="block text-sm font-medium leading-6">
          <span className="sr-only">{translate("search")}</span>
        </label>
        <div className="mt-2 w-full">
          <Button type="submit" className="w-full bg-white rounded-md px-3 text-brand-500 py-2 border-solid border-brand-500 border-[1px] hover:bg-white active:bg-white active:opacity-85" onClick={_handleSubmitFilter}>
            <SearchIcon className="w-3 h-4 text-brand-500 mr-2" /> {translate("search")}
          </Button>
        </div>
      </div>
    </div>
  )
}